import React from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Navbar from './Navbar';
import Footer from './Footer';
import { useTheme } from '../hooks/useTheme';
import { useSidebar } from '../hooks/useSidebar';

const Layout = () => {
  const { theme, toggleTheme } = useTheme();
  const { 
    isCollapsed, 
    isMobileOpen, 
    toggleCollapsed, 
    toggleMobile, 
    closeMobile 
  } = useSidebar();

  return (
    <>
      {/* Skip to main content link for accessibility */}
      <a 
        href="#mainContent" 
        className="visually-hidden-focusable btn btn-primary position-absolute top-0 start-0 m-2"
        style={{ zIndex: 1030 }}
      >
        Skip to main content
      </a>
      
      {/* Live region for dynamic announcements */}
      <div 
        id="liveRegion" 
        className="visually-hidden" 
        aria-live="polite" 
        aria-atomic="true"
      ></div>

      <Sidebar 
        isCollapsed={isCollapsed}
        isMobileOpen={isMobileOpen}
        onCloseMobile={closeMobile}
      />

      <div className={`main-content ${isCollapsed ? 'sidebar-collapsed' : ''}`} id="mainContent">
        <Navbar 
          onToggleSidebar={toggleCollapsed}
          onToggleMobileSidebar={toggleMobile}
          theme={theme}
          onToggleTheme={toggleTheme}
        />
        
        <main className="container-fluid p-4" role="main">
          <Outlet />
        </main>
        
        <Footer />
      </div>
    </>
  );
};

export default Layout;
